import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    width: 10,
    height: 10,
    zIndex: 1000,
    elevation: 1000,
    backgroundColor: '#000000',
  },
});
